import { Trophy } from "lucide-react";
import PhotoSlider from "@/components/site/PhotoSlider";

const slides = [
  { id: "sports-1", label: "Sports Day — Photo 1" },
  { id: "sports-2", label: "Sports Day — Photo 2" },
  { id: "sports-3", label: "Sports Day — Photo 3" },
  { id: "sports-4", label: "Sports Day — Photo 4" },
];

export default function SportsDay() {
  return (
    <section
      id="sports-day"
      data-testid="sports-day-section"
      className="relative overflow-hidden bg-slate-50 py-14 md:py-24"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 bottom-20 h-72 w-72 rounded-full bg-orange-200/40 blur-3xl"
      />
      <div className="container mx-auto px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-red-700">
            <Trophy className="h-3.5 w-3.5" />
            Sports Day
          </div>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Books, plus a bit of{" "}
            <span className="text-red-600">healthy fire.</span>
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600 md:text-base">
            Our annual Sports Day reminds students that consistency,
            teamwork and discipline matter just as much off the page.
          </p>
        </div>

        <div className="mt-10 md:mt-14">
          <PhotoSlider
            testid="sports-day-slider"
            slides={slides}
            accentIcon={Trophy}
          />
        </div>
      </div>
    </section>
  );
}
